import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

import DynamicForm from "../yoello-lib/modules/dynamicForms/DynamicForms";
import EColourPanel from "../interfaces/EColourPanel";
import { createVenueTypesFormRows } from "../formSchemas/createVenueTypesFormRows.form";
import IVenue from "../interfaces/IVenue";
import { IVenueType, IVenueTypes } from "./menu/Details";
import { useAPIV2 } from "../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../yoello-lib/modules/API2/APIDefs";
import { IReduxAppState } from "../reducers";
import { HTTPMethods } from "../yoello-lib/modules/API/API";
import ListLoading from "./util/Loading";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
  })
);

interface Props {
  venue: IVenue;
}

export const VenueTypesModal = (props: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const selectedVenueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  );

  const outstandingData = useSelector(
    (state: IReduxAppState) => state.outstanding.body
  );

  const venue_type_id = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueData?.venue_type_id);

  const { callAPI: callVenues } = useAPIV2<IVenue>(APIExtensions.venues, {
    query: selectedVenueId,
    canAPIGetCacheValue: true,
    selectorKeyParams: { venue_id: selectedVenueId },
    dispatcherParams: [selectedVenueId],
    onMountDisabled: true,
  });

  const { apiData: venueTypesData } = useAPIV2<IVenueTypes>(
    APIExtensions.venueTypes,
    {
      canAPIGetCacheValue: true,
      selectorKeyParams: { venue_id: selectedVenueId },
      dispatcherParams: [selectedVenueId],
    }
  );

  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const iOpen =
    !venue_type_id &&
    (outstandingData
      .find((task) => task.task === "details")
      ?.items.every((item) => item.complete) as boolean);

  useEffect(() => {
    setOpen(iOpen);
  }, [iOpen, selectedVenueId]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (data: any) => {
    const venue_type_id = data.venue_type_id.value;

    setIsLoading(true);

    await callVenues(HTTPMethods.PUT, {
      query: selectedVenueId,
      body: {
        venue_type_id,
      },
    });

    setIsLoading(false);

    setOpen(false);

    window.location.reload();
  };

  const getVenueTypes = () => {
    return venueTypesData?.map((venueType: IVenueType) => {
      return {
        name: t(`forms.details.venueType_${venueType.internal_name}`),
        value: venueType.id,
      };
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEscapeKeyDown
      disableBackdropClick
      className={classes.root}
      style={{ zIndex: 9999 }}
    >
      <DialogTitle id="alert-dialog-title">
        {t("forms.details.modalTitle", { name: props.venue?.venue_name })}
      </DialogTitle>

      <DialogContent>
        {isLoading ? (
          <ListLoading />
        ) : (
          <DynamicForm
            onHandleSubmit={handleSubmit}
            formData={{}}
            formRows={createVenueTypesFormRows(getVenueTypes)}
            formKeyName="submit"
            formButtons={{
              rightButton: {
                type: "submit",
                label: t("forms.details.modalButton"),
                color: EColourPanel.PRIMARY,
                fullWidth: true,
              },
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
